import { z } from "zod";

const ReconciliationRunSchema = z.object({
  id: z.string().uuid(),
  run_id: z.string().uuid(),
  cadence: z.enum(["Cut", "Intraday"]),
  as_of_date: z.string().nullable(),
  venue_account_id: z.string().uuid(),
  venue_symbol: z.string(),
  instrument_name: z.string().nullable(),
  venue_size: z.string().nullable(),
  gap: z.string().nullable(),
  residual: z.string().nullable(),
  mark: z.string().nullable(),
  residual_notional: z.string().nullable(),
  book_size: z.string(),
  unassigned_size: z.string(),
  mark_source: z.string().nullable(),
  reason: z.string().nullable(),
  status: z.enum(["Clear", "Explained", "Break", "Unreconciled"]),
  venue_captured_at: z.string().nullable(),
  captured_at: z.string(),
  break_id: z.string().uuid().nullable(),
});

export { ReconciliationRunSchema };
